import { goodsBelongLabels } from 'json/mall-options'
export let goodsSelectFactorFileterLables = [
  {
    label: '名称',
    type: 'input',
    clearable: true,
    value: 'name'
  },
  {
    label: '归属',
    type: 'select',
    clearable: true,
    value: 'goodsBelong',
    options: goodsBelongLabels
  },
  {
    label: '分组',
    type: 'select',
    clearable: true,
    value: 'groupId', // 需返回数据的字段名
    options: [],
    props: {
      label: 'name',
      value: 'id'
    }
  },
  {
    label: '类型',
    type: 'select',
    clearable: true,
    value: 'type', // 需返回数据的字段名
    options: [],
    props: {
      label: 'name',
      value: 'value'
    }
  },
  {
    label: '价格',
    clearable: true,
    type: 'price-slot',
    minName: 'priceIntervalMin',
    maxName: 'priceIntervalMax',
    value: 'priceInterval'
  }
]
// 选择检测项顶部tab
export let detectionTags = [
  {
    label: '全部',
    value: 'all'
  },
  {
    label: '常见疾病',
    value: 'COMMON_DISEASES'
  },
  {
    label: '高危遗传病',
    value: 'GENETIC_DISEASES'
  },
  {
    label: '罕见病',
    value: 'RARE_DISEASES'
  },
  {
    label: '药物基因组',
    value: 'PHARMACOGENOMICS'
  },
  {
    label: '生活方式',
    value: 'LIFE_STYLE'
  }
]
// 检测项选择列表表头
export let tagsTableLabels = [
  {
    label: '中文名称',
    value: 'chineseName'
  },
  {
    label: '英文名称',
    value: 'englishName'
  },
  {
    label: '类型',
    value: 'detection_category'
  }
]
